import { JobQueries } from '@/graphql/queries/job.queries'
import { JobTemplate } from '@/types/Job'

import { useGraphql } from '../useGraphql'

const useJobTemplates = () => {
  return useGraphql<{ jobTemplates: JobTemplate[] }>(
    JobQueries.QUERY_KEYS.getJobTemplates,
    JobQueries.getJobTemplates(),
  )
}

export default useJobTemplates
